import { Box, Typography } from '@mui/material'
import InfoTooltip from 'components/InfoTooltip'

interface ChartTitleProps {
  children: React.ReactNode
  tooltip?: string
  right?: React.ReactNode
}

const ChartTitle = ({ children, tooltip, right }: ChartTitleProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant='h6' sx={{ fontWeight: 700, color: 'text.primary' }}>
        {children}
      </Typography>
      {tooltip && (
        <Box sx={{ marginTop: 1 }}>
          <InfoTooltip title={tooltip} />
        </Box>
      )}
    </Box>
    {right}
  </Box>
)

export default ChartTitle
